import React, { useState, useEffect } from "react";
import { Stage, Layer, Image, Rect } from "react-konva";
import ContextMenu from "../ContextMenu";
import Rectangle from "./Rectangle";
import PropertiesMenu from "../PointPropertiesMenu/PropertiesMenu";
import Icon from "../Icon";
import { RiAddCircleLine } from "react-icons/ri";

// TODO: add (togglable) arrow pointing out from the coaching point, and point it at a target node.
// This target node will be invisible in read mode.
// Also, possibly make the line an editable bezier curve

// REMINDER: when adding functionality that relies on a point being selected,
// you must use the 'selection' variable to ensure you have the correct selection

let selection = null;
let tempPoint = null;
// eslint-disable-next-line no-unused-vars
let tempArray = null;

const CoachCanvas = (props) => {
  const {
    background,
    stageRef,
    canvasWidth,
    canvasHeight,
    scale,
    bgRef,
    rects,
    points,
    pointColor,
    setPoints,
    triggers,
    fill,
    colorPickerVisible,
    readFill,
    readOpacity,
    updatePointCoords,
    setListening,
    bookId,
  } = props;

  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: null,
    y: null,
  });
  const [propertiesMenu, setPropertiesMenu] = useState({
    visible: false,
    x: null,
    y: null,
  });

  useEffect(() => {
    if (propertiesMenu.visible) {
      document.addEventListener("keydown", handleKeyDown);
    }
    if (!propertiesMenu.visible) {
      document.removeEventListener("keydown", handleKeyDown);
    }
  }, [propertiesMenu]);

  const handleKeyDown = (e) => {
    // if (e.key === "Escape") {
    //   setPropertiesMenu({ ...propertiesMenu, visible: false });
    //   setListening(true);
    // }
    if (e.key === "s" && e.metaKey) e.preventDefault();
  };

  useEffect(() => {
    if (points) tempArray = points.slice();
  }, [points]);

  // useEffect(() => {
  //   console.log('points array:', points);
  //   console.log(
  //     'points selected:',
  //     points.map((p) => {
  //       return p.selected;
  //     })
  //   );
  // }, [points]);

  const selectObject = (point) => {
    selection = point;
    tempArray = points.slice();
    for (let i = 0; i < points.length; i++) {
      if (points[i].id === selection.id) {
        tempPoint = points[i]; //grab the point located at index i
        break;
      }
    }
    // setPoints(
    //   points.map((p) => {
    //     if (p.id === point.id) {
    //       return {
    //         ...p,
    //         selected: true,
    //       };
    //     } else
    //       return {
    //         ...p,
    //         selected: false,
    //       };
    //   })
    // );
  };

  // user clicked on the stage
  const handleStageClick = (e) => {
    if (contextMenu.visible) {
      setListening(true);
      hideContextMenu();
      return;
    }
    deselectAll();
    // if the user right-clicks
    if (e.evt.button === 2) {
      if (e.target !== bgRef.current) selectObject(e.target);
      if (!propertiesMenu.visible) {
        generateContextOptions(e);
        showContextMenu(e);
        return;
      }
    }
  };

  const handlePointClick = (e, point) => {
    selectObject(point);
    showPropertiesMenu(e);
  };

  const createPoint = () => {
    setListening(true);
    hideContextMenu();
    const pointToAdd = {
      x: stageRef.current.getPointerPosition().x / scale.x,
      y: stageRef.current.getPointerPosition().y / scale.x,
      id: points ? points.length : 0,
      name: "point",
      scale: 50,
      color: pointColor,
      selected: false,
      title: null,
      link: null,
      icon: "?",
      // customText: null,
      direction: "bottom",
    };
    let temp = points ? points.slice() : [];
    temp.push(pointToAdd);
    setPoints(temp);
  };

  const deselectAll = () => {
    if (points)
      setPoints(
        points.map((point) => {
          return {
            ...point,
            selected: false,
          };
        })
      );
  };

  const updatePointProps = (newPoint) => {
    setPoints(
      points.map((point) => {
        if (newPoint.id === point.id) {
          return {
            ...point,
            scale: newPoint.scale,
            color: newPoint.color,
            title: newPoint.title,
            link: newPoint.link,
            iconUrl: newPoint.iconUrl,
            // customText: newPoint.customText,
            direction: newPoint.direction,
            audioTracks: newPoint.audioTracks,
            subtitles: newPoint.subtitles,
          };
        } else return point;
      })
    );
  };

  const deleteObject = () => {
    setPropertiesMenu({ ...propertiesMenu, visible: false });
    setListening(true);
    hideContextMenu();
    let temp = [...points];
    temp.splice(selection.id, 1);
    temp.forEach((point, i) => {
      point.id = i;
    });
    setPoints(temp);
  };

  const generateContextOptions = (e, point = false) => {
    if (e.target === stageRef.current || e.target === bgRef.current) {
      setContextMenuOptions([
        {
          name: "New coaching point",
          icon: <RiAddCircleLine size={20} />,
          func: createPoint,
        },
      ]);
    }
  };

  const showContextMenu = (e) => {
    e.evt.preventDefault();
    setListening(false);
    setContextMenu({
      ...contextMenu,
      x: stageRef.current.getPointerPosition().x,
      y: stageRef.current.getPointerPosition().y,
      visible: true,
    });
  };

  const showPropertiesMenu = (e) => {
    // let offsetX,
    //   offsetY = 0;
    // // if the pointer is too far to the right,
    // if (
    //   stageRef.current.getPointerPosition().x +
    //     (window.innerWidth - canvasWidth) / 2 +
    //     540 >
    //   window.innerWidth
    // )
    // //bring it to the left only as much as necessary
    //   offsetX =
    //     stageRef.current.getPointerPosition().x +
    //     (window.innerWidth - canvasWidth) / 2 +
    //     540 -
    //     window.innerWidth;
    // else offsetX = 0;
    e.evt.preventDefault();
    setListening(false);
    hideContextMenu();
    setPropertiesMenu({
      ...propertiesMenu,
      // x: stageRef.current.getPointerPosition().x - offsetX,
      x: stageRef.current.getPointerPosition().x,
      y: stageRef.current.getPointerPosition().y,
      visible: true,
    });
  };

  const hideContextMenu = () => {
    setContextMenu({
      ...contextMenu,
      visible: false,
    });
  };

  const [contextMenuOptions, setContextMenuOptions] = useState([]);

  return (
    <div className="canvas">
      <Stage
        scale={scale}
        ref={stageRef}
        width={canvasWidth}
        height={canvasHeight}
        // onContextMenu={showContextMenu}
        onClick={handleStageClick}
      >
        <Layer>
          <Image image={background} ref={bgRef} />
        </Layer>
        <Layer>
          {rects &&
            rects.map((rect, index) => {
              return (
                <Rectangle
                  key={index}
                  index={index}
                  id={String(index)}
                  x={rect.x}
                  y={rect.y}
                  width={rect.width}
                  height={rect.height}
                  draggable={false}
                  fill={colorPickerVisible ? readFill : fill}
                  opacity={colorPickerVisible ? readOpacity : 1}
                  stroke={colorPickerVisible ? "" : "gray"}
                  strokeWidth={colorPickerVisible ? 0 : 1}
                  dash={[4, 3]}
                  rect={rect}
                />
              );
            })}
        </Layer>
        <Layer>
          {triggers &&
            triggers.map((trigger, index) => {
              if (trigger.type === "rect") {
                return (
                  <Rect
                    key={index}
                    x={trigger.x}
                    y={trigger.y}
                    width={trigger.width}
                    height={trigger.height}
                    fill="#00000040"
                    stroke={"gray"}
                    opacity={0.4}
                    strokeWidth={1}
                    dash={[4, 3]}
                  />
                );
              } else {
                return (
                  <Icon
                    id={trigger.id}
                    key={trigger.id}
                    x={trigger.x}
                    y={trigger.y}
                    iconUrl={trigger.iconUrl}
                    color={trigger.color}
                    scale={trigger.scale}
                    canvasWidth={canvasWidth}
                    canvasHeight={canvasHeight}
                    canvasScale={scale}
                    opacity={0.25}
                  />
                );
              }
            })}
        </Layer>
        <Layer>
          {points &&
            points.map((point) => {
              return (
                <Icon
                  id={point.id}
                  key={point.id}
                  x={point.x}
                  y={point.y}
                  iconUrl={point.iconUrl}
                  symbol={point.icon || "?"}
                  direction={point.direction}
                  // customText={point.customText}
                  color={point.color}
                  listening={!propertiesMenu.visible}
                  draggable={true}
                  scale={point.scale}
                  canvasWidth={canvasWidth}
                  canvasHeight={canvasHeight}
                  canvasScale={scale}
                  selected={point.selected}
                  // handleDragStart={handleDragStart}
                  onClick={(e) => {
                    e.cancelBubble = true;
                    handlePointClick(e, point);
                  }}
                  updatePointCoords={updatePointCoords}
                />
              );
            })}

          {contextMenu.visible && (
            <ContextMenu id="contextMenu" x={contextMenu.x} y={contextMenu.y} options={contextMenuOptions} />
          )}
        </Layer>
      </Stage>
      {propertiesMenu.visible && (
        <PropertiesMenu
          bookId={bookId}
          id="propertiesMenu"
          x={propertiesMenu.x}
          y={propertiesMenu.y}
          points={points}
          setPoints={setPoints}
          target={tempPoint}
          color={pointColor}

          // originalText={
          //   tempPoint.customText === null
          //     ? tempPoint.id + 1
          //     : tempPoint.customText
          // }
          propertiesMenu={propertiesMenu}
          setPropertiesMenu={setPropertiesMenu}
          setListening={setListening}
          updatePointProps={updatePointProps}
          deleteObject={deleteObject}
        />
      )}
    </div>
  );
};

export default CoachCanvas;
